import { AuthorImageProps } from "@topgun/shared/src/types/frontend";

export const getBackgroundPositionCssForImageWithFocalPoint = (
  image: AuthorImageProps | undefined,
) => {
  const positionX = image?.focalPoint?.left ? `${image?.focalPoint?.left}%` : "center";
  const positionY = image?.focalPoint?.top ? `${image?.focalPoint?.top}%` : "center";

  return `
		background-position-x: ${positionX};
        background-position-y: ${positionY};
    `;
};
